import { ReactElement } from 'react';
import Course1 from './Course1/Course1';
import Course2 from './Course2/Course2';
import Course3 from './Course3/Course3';
import Course4 from './Course4/Course4';
import Course5 from './Course5/Course5';
import Course6 from './Course6/Course6';
import Course7 from './Course7/Course7';
import Course8 from './Course8/Course8';
import Course9 from './Course9/Course9';
import Course10 from './Course10/Course10';

interface Props {
  showCourse: number;
}

const CourseMaterial = (props: Props): ReactElement => {
  const { showCourse } = props;
  return (
    <>
      {showCourse === 1 ? <Course1 /> : false}
      {showCourse === 2 ? <Course2 /> : false}
      {showCourse === 3 ? <Course3 /> : false}
      {showCourse === 4 ? <Course4 /> : false}
      {showCourse === 5 ? <Course5 /> : false}
      {showCourse === 6 ? <Course6 /> : false}
      {showCourse === 7 ? <Course7 /> : false}
      {showCourse === 8 ? <Course8 /> : false}
      {showCourse === 9 ? <Course9 /> : false}
      {showCourse === 10 ? <Course10 /> : false}
    </>
  );
};

export default CourseMaterial;
